import { Observable } from 'rxjs';
import { LoginResult } from './data/login-result';
import { SessionChangedData } from './data/session-changed-data';

export type SUCCESS_TYPE = 'SUCCESS';

export class RegistrationData {
  unifiedTaxIdLast4Digits: string;
  email: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  invitationId: string;
}

export class ConfirmRegistrationData {
  username: string;
  confirmationCode: string;

  constructor(username: string, confirmationCode: string) {
    this.username = username;
    this.confirmationCode = confirmationCode;
  }
}

export class ResendConfirmationData {
  username: string;

  constructor(username: string) {
    this.username = username;
  }
}

export const VENDOR_AUTH_SERVICE = 'VENDOR_AUTH_SERVICE';

export interface AuthService {
  login(username: string, password: string): Observable<LoginResult>;

  sendMFACode(confirmationCode: string, username: string, mfaOption: string): Observable<LoginResult>;

  associateEmailToken(): Observable<SUCCESS_TYPE>;

  verifyEmailToken(code: string): Observable<string>;

  getUserMfaOptions(): Observable<string[]>;

  disableMfa(): Observable<string>;

  logout(): void;

  isAuthenticated(): Observable<SessionChangedData>;

  refreshSession(): Observable<SessionChangedData>;

  changePassword(oldPassword: string, newPassword: string): Observable<SUCCESS_TYPE>;

  associateSoftwareToken(username: string): Observable<Record<'secretCode' | 'qrValue', string>>;

  verifySoftwareToken(username: string, token: string): Observable<unknown>;

  register(user: RegistrationData): Observable<SUCCESS_TYPE>;

  confirmRegistration(username: string, confirmationCode: string): Observable<SUCCESS_TYPE>;

  forgotUsername(email: string): Observable<SUCCESS_TYPE>;

  forgotPassword(username: string): Observable<SUCCESS_TYPE>;

  resendRecoveryCode(username: string): Observable<SUCCESS_TYPE>;

  recoverPassword(verificationCode: string, newPassword: string, username: string): Observable<SUCCESS_TYPE>;

  resendConfirmationMail(username: string): Observable<SUCCESS_TYPE>;

  notifyMfaSetup(): Observable<SUCCESS_TYPE>;

  notifyEmailMfaSetup(): Observable<SUCCESS_TYPE>

  getUserSessionToken(): Observable<string>;
}
